export default "__VITE_ASSET__DBQesKhR__"